import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import Icons from "../svg/Icons.ts";
import ApiServer from "../ApiServer.ts";
import * as segment from "../tracking-segment.ts";

export {initDom}
Html.registerWidget('contact/widget-note-updater',{initDom})


function initDom(element: HTMLElement){
  element.addEventListener('change', function(this: HTMLInputElement){
    const metaId = Html.getDomMetaId(element);
    const contact = FwDatas.get(metaId);

    contact.note = this.value;
    ApiServer.ctcput(contact,function(){
      //the inline note editor does not publish contactUpdated
      segment.track("Contact Edited");
      modal.toast({svg:Icons.ic_done,text:"contact.notesaved"})
    })
  });
}